import React from 'react';

import UICounter from './component';

export default React.memo(UICounter);
